import { HttpClient } from '@angular/common/http'
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core'
import { GoogleMap } from '@angular/google-maps'
import { environment } from 'src/environments/environment'
import { BranchInformationModel, UpdateLocationModel } from '../../models/branch-information.model'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { OrganizationsService } from '../../services/organizations.service'
import { Subscription } from 'rxjs'
import { TranslateService } from '@ngx-translate/core'
import { LoadingService } from 'src/app/shared/services/loading.service'

@Component({
	selector: 'app-organization-branch-location',
	templateUrl: './organization-branch-location.component.html',
	styleUrls: ['./organization-branch-location.component.scss'],
})
export class OrganizationBranchLocationComponent
	implements OnInit, OnChanges, OnDestroy
{
	@ViewChild('inputField') inputField!: ElementRef
	@ViewChild('map') map!: GoogleMap
	@Input() branchInformationData!: BranchInformationModel
	@Output() dataChanged: EventEmitter<any> = new EventEmitter()

	subscription = new Subscription()
	position!: google.maps.LatLng | google.maps.LatLngLiteral
	autoComplete: google.maps.places.Autocomplete | undefined
	zoom!: number
	center!: google.maps.LatLngLiteral
	isEmptyInput: boolean = true
	editMode: boolean = false
	locationForm!: FormGroup
	locationToSave!: { latitude: number; longitue: number }
	errorChooseLocation = false
	constructor(
		public translate: TranslateService,
		private http: HttpClient,
		private organizationsService: OrganizationsService,
		private loading: LoadingService
	) {}

	ngOnChanges(): void {
		this.initMap()
		this.initForm()
	}

	ngOnInit(): void {}

	initForm() {
		this.locationForm = new FormGroup({
			id: new FormControl(this.branchInformationData?.id),
			locationSearch: new FormControl(this.branchInformationData?.address, [
				Validators.required,
			]),
			shortAddressEn: new FormControl(
				this.branchInformationData?.shortAddressEn
			),
			shortAddressAr: new FormControl(
				this.branchInformationData?.shortAddressAr
			),
		})
	}

	initMap() {
		if (
			this.branchInformationData?.address &&
			this.branchInformationData?.latitude
		) {
			this.center = {
				lat: this.branchInformationData?.latitude,
				lng: this.branchInformationData?.longitude,
			}
			this.zoom = 14
		} else {
			this.center = { lat: 30.033333, lng: 31.233334 }
			this.zoom = 6
		}
		this.position = this.center
	}

	ngAfterViewInit(): void {
		this.autoComplete = new google.maps.places.Autocomplete(
			this.inputField?.nativeElement
		)

		this.autoComplete.addListener('place_changed', () => {
			this.loading.showSpinner()
			const place = this.autoComplete?.getPlace()
			this.position = place?.geometry?.location as google.maps.LatLng
			this.locationToSave = {
				latitude: this.position.lat(),
				longitue: this.position.lng(),
			}
			this.getController('locationSearch').setValue(place?.formatted_address)
			const country = place?.address_components?.find(
				(res: any) => res.types[0] == 'country'
			)?.short_name
			country != this.branchInformationData?.country?.countryCode
				? (this.errorChooseLocation = true)
				: (this.errorChooseLocation = false)
			this.map.panTo(this.position)
			this.loading.hideSpinner()
		})
	}

	onMarkerDropped(event: any) {
		this.locationToSave = {
			latitude: event.latLng.lat(),
			longitue: event.latLng.lng(),
		}
		this.position = {
			lat: this.locationToSave.latitude,
			lng: this.locationToSave.longitue,
		}
		this.getAddress(event.latLng.lat(), event.latLng.lng()).then(value =>{
      this.getController('locationSearch').setValue(
        value.results[0].formatted_address
      )
      const country = value.results[
      value.results?.length - 2
        ]?.address_components?.find((res: any) => res.types[0] == 'country')
      country?.short_name != this.branchInformationData?.country?.countryCode
        ? (this.errorChooseLocation = true)
        : (this.errorChooseLocation = false)
    }

		)
		this.locationForm.controls['shortAddressEn'].setValue('')
		this.locationForm.controls['shortAddressAr'].setValue('')
	}

	onEditClicked() {
		this.editMode = true

		if (this.branchInformationData?.hasAppointments) {
			this.locationForm.disable()
		}
	}

	update() {
		const body: UpdateLocationModel = {
			id: this.branchInformationData.id,
			// ...this.locationForm.getRawValue(),
			address: this.getController('locationSearch').value,
			latitude: this.locationToSave?.latitude,
			longitude: this.locationToSave?.longitue,
			// // addressNote: 'notes',
			shortAddressAr: this.locationForm?.get('shortAddressAr')?.value,
			shortAddressEn: this.locationForm?.get('shortAddressEn')?.value,
		}

		this.subscription.add(
			this.organizationsService.updateBranchLocation(body).subscribe((res) => {
				this.branchInformationData.address = body.address
				this.branchInformationData.shortAddressAr = body.shortAddressAr
				this.branchInformationData.shortAddressEn = body.shortAddressEn
				// this.branchInformationData.latitude = body.latitude
				// this.branchInformationData.longitude = body.longitude
				this.editMode = false
				this.dataChanged.emit()
			})
		)
	}

	private async getAddress(lat: number, lng: number) {
		const res = await fetch(
			`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${environment.googleMapKey}`
		)
    return res.json();
	}

	onCancelClicked() {
		this.editMode = false
		this.getController('locationSearch').setValue(
			this.branchInformationData?.address
		)
		this.initMap()
		this.errorChooseLocation = false
	}

	getController(controlName: string) {
		return this.locationForm.controls[controlName] as FormControl
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe()
	}
}
